// eslint-disable-next-line @typescript-eslint/no-empty-interface
import {Box, Container, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useContext} from "react";
import {useNavigate} from "react-router-dom";
import {FetchMessage, STATUSES} from "../../../hooks/useFetchAllQuery";
import SearchForm from "../components/forms/SearchForm";
import SortOrder from "../components/forms/SortOrder";
import {OBJECT_LIST_SORT_ORDERS, OPERATING_ENVIRONMENT_URLS} from "../../../constants/constants";
import {ObjectListItem} from "../components/lists/ObjectListItem";
import {
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  DataStoreType,
  ObjectListPayload
} from "../contexts/OperatingEnvironmentContext";
import {sortObjects} from "../utils/operatingEnvironmentUtil";
import {useObject} from "../hooks/useObject";

export default function ObjectList() {
  const {state, dispatch} = useContext(DataStoreContext);
  const navigate = useNavigate();
  const {fetchAll} = useObject({
    searchCond: state.objectList.searchCond,
    onChange: (newData, newStatus) => {
      dispatch({
        type: CONTEXT_ACTION_TYPE.OBJECT_LIST,
        payload: {objects: newData, searchStatus: newStatus} satisfies ObjectListPayload
      });
    },
  });
  const objects = state.objectList.objects.map(item => Object.values(item.object)).flat();

  return (
    <Container maxWidth={false} sx={{mt: 2}}>
      <Stack gap={4}>
        <SearchForm
          label="パッケージ名、オブジェクト名などを入力"
          isLoading={state.objectList.searchStatus === STATUSES.FETCHING}
          searchCond={state.objectList.searchCond}
          onChange={(searchCond) => {
            dispatch({type: CONTEXT_ACTION_TYPE.OBJECT_LIST, payload: {searchCond} satisfies ObjectListPayload});
          }}
          onSubmit={(e) => {
            e.preventDefault();
            fetchAll().catch(console.error);
          }}
        />

        <Grid container alignItems="end" sx={{flexWrap: "nowrap"}} size={{xs: 12}}>
          <Grid size="grow">
            <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
              検索結果一覧
            </Typography>
          </Grid>
          <Grid size="auto">
            <Grid container alignItems="center" spacing={2} sx={{flexWrap: "nowrap"}}>
              <Grid>
                <Box component="span">
                  {objects.length > 0 ? `${objects.length.toLocaleString()}件` : ""}
                </Box>
              </Grid>
              <Grid>
                <Box component="span">
                  <SortOrder
                    value={state.objectList.searchCond.sortOrder}
                    onChange={(event) => {
                      dispatch({
                        type: CONTEXT_ACTION_TYPE.OBJECT_LIST,
                        payload: {
                          searchCond: {
                            ...state.objectList.searchCond,
                            sortOrder: event.target.value as DataStoreType["objectList"]["searchCond"]["sortOrder"],
                          }
                        } satisfies ObjectListPayload
                      });
                    }}
                    items={Object.values(OBJECT_LIST_SORT_ORDERS)}/>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {objects.length > 0 && (
          <Grid container alignItems="stretch" spacing={2}>
            {sortObjects(objects, state.objectList.searchCond.sortOrder)
              .map(item => (
                <Box
                  key={item.attr['object-id']}
                  display='flex'
                  gap={4}
                  onClick={() => navigate(`${OPERATING_ENVIRONMENT_URLS.OBJECT_DETAIL.URL}/${item.attr["object-id"]}`)}
                >
                  <ObjectListItem item={item}/>
                </Box>
              ))}
          </Grid>
        )}

        <FetchMessage
          data={state.objectList.objects}
          status={state.objectList.searchStatus}
          isEmpty={(value) => Object.values(value?.[0]?.object ?? {}).length === 0}
        />
      </Stack>
    </Container>
  );
}
